<template>
  <round :device="device" :class="{ts:isSanXK}">
    <div class="sh">
      <img :src="icon" style="height: 65px;"/>
      <p class="dl" :class="!Number(device.state.dl) ? 'visibility' : ''">电量：{{device.state && Number(device.state.dl || 0).toFixed(2)}}度</p>
      <div class="sx" v-if="isSanXK">
          <p  class="dl" :class="!Number(device.state.ady) ? 'visibility' : ''">A电压：{{device.state && device.state.ady || 0}} V</p>
          <p  class="dl" :class="!Number(device.state.bdy) ? 'visibility' : ''">B电压：{{device.state && device.state.bdy || 0}} V</p>
          <p  class="dl" :class="!Number(device.state.cdy) ? 'visibility' : ''">C电压：{{device.state && device.state.cdy || 0}} V</p>
      </div>
      <p v-else class="dl" :class="!Number(device.state.dy) ? 'visibility' : ''">电压：{{device.state && device.state.dy || 0}} V</p>
      <div slot="footer" class="footer">
          <div class="text" v-text="text"></div>
      </div>
    </div>
  </round>
</template>
<script>
import Round from './Round'
import api from '../model/device'

export default {
  name: 'Wisdom',
  data () {
    return {
      // state: false
      timer: null
    }
  },
  props: {
    device: {
      type: Object,
      required: true
    }
  },
  computed: {
    icon () {
      if (this.device.state.state) {
        return require('../assets/images/device/switch/air_switc.png')
      } else {
        return require('../assets/images/device/switch/air_switch_off.png')
      }
    },
    text () {
      if (this.device.state.state) {
        return '已开启'
      } else {
        return '已关闭'
      }
    },
    isSanXK () {
      // 是否是三项空开
      return this.device && this.device.cmd && this.device.cmd && this.device.cmd.action && this.device.cmd.action.indexOf('selectA') > -1
    }
  },
  components: {
    Round
  },
  methods: {
    // 轮训获取电量
    getElectricity () {
      // {'cmd':80,'nd':180,'addr':1,'reg':40003,'len':1}
      // https://iot.datatellit.com/v1/devices/2b003d001747373034353238/JSONCommand?access_token=7f37e1547c41113704c035828dd662213b403400
      this.timer = setInterval(async () => {
        api.singleControl(this.device, 'select')
      }, 1000 * 15)

      //   const result = await this.axios.post(config.iot + '/v1/devices/2c0028001747373034353238/JSONCommand', {
      //     arg: { 'cmd': 80, 'nd': this.device.nd, 'addr': this.device.sid, 'reg': 30000, 'len': 9 }
      //   }, {
      //     headers: {
      //       'Content-Type': 'application/x-www-form-urlencoded'
      //     },
      //     transformRequest: function (data) {
      //       return `arg=${JSON.stringify(data.arg)}`
      //     }
      //   })
      // }, 1000 * 5)
    }
  },
  deactivated () {
    // 清除页面的定时器，定时器主要用于切换当前课程
    this.timer && clearInterval(this.timer)
  },
  mounted () {
    this.timer && clearInterval(this.timer)
    // 新疆项目不需要查询状态，否则影响控制
    if(this.device && (this.device.zoneId == 5862 || this.device.zoneId == 58622)){
      return;
    }
    this.getElectricity()
  },
  activated () {
    this.timer && clearInterval(this.timer)
    // 新疆项目不需要查询状态，否则影响控制
    if(this.device && (this.device.zoneId == 5862 || this.device.zoneId == 58622)){
      return;
    }
    this.getElectricity()
  }

}
</script>
<style scoped lang="less">
.round {
  .sx {
    .dl {
      text-align: left;
    }
  }
  .dl {
    margin: 0;
    padding: 0;
    text-align: center;
    padding-top: 2px;
    position: relative;
    left: -15px;
  }
  .visibility {
    visibility: hidden;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
  }
  .text {
    position: relative;
    left: -20px;
  }
}
.ts {

   /deep/.footer {
      position: relative;
      top: -17px;
      //padding: 0 !important;
    }

}

.sh {
    margin-bottom: 30px;
    height: 80px;
}
</style>
